import { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { ApiClient } from '../api/api-client';

export default function ACLProtectedRoute({ aclName }) {
  const [auth, authenticated] = useState(null);
  const location = useLocation();

  function isAuthorized(privileges) {
    return privileges && privileges.some((privilege) => privilege.name === aclName);
  }

  useEffect(() => {
    ApiClient.getInstance()
      .getSession()
      .then((res) => {
        sessionStorage.setItem('userId', res.data.id);
        sessionStorage.setItem('username', res.data.name);
        sessionStorage.setItem('systemAccount', (res.data.systemAccount === true).toString());

        if (isAuthorized(res.data.privileges) && res.data.systemAccount !== true) {
          authenticated(true);
        } else {
          authenticated(false);
          sessionStorage.setItem('redirectAfterLogin', location.pathname + location.search);
        }

      })
      .catch(() => {
        authenticated(false);
        sessionStorage.setItem('redirectAfterLogin', location.pathname + location.search);
      } );
  }, []);
  if (auth === null) return <div> </div>;
  if (auth === false) return <Navigate to="/" replace />;
  return <Outlet />;
}